// extracted by mini-css-extract-plugin
module.exports = {"NewsSlider__Container":"dFMvB","NewsSlider":"_7WDCs","NewsSlider__Card":"_5M2j8"};